// extracted by mini-css-extract-plugin
export default {"footer":"f6aPLSXpefivN80vUr79"};